import React, { useState, useEffect } from "react";

const AddStockModal = ({ isOpen, onClose, onManualEntry, onFileUpload, onAIPhotoScan }) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleManualClick = () => {
    onManualEntry?.();
    onClose();
  };

  const handleFileClick = () => {
    onFileUpload?.();
    onClose();
  };

  const handleAIClick = () => {
    onAIPhotoScan?.();
    onClose();
  };

  return (
    <>
      <style>{`
            @keyframes slFadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes slModalSlideUp {
              from { 
                transform: translate(-50%, -50%) scale(0.9);
                opacity: 0;
              }
              to { 
                transform: translate(-50%, -50%) scale(1);
                opacity: 1;
              }
            }
            .sl-card-hover:hover {
              border-color: #2563eb !important;
              background: #f8faff !important;
              transform: translateY(-2px);
              box-shadow: 0 8px 20px rgba(37, 99, 235, 0.15);
            }
            .sl-close-hover:hover {
              background: #e5e7eb !important;
              transform: rotate(90deg);
            }
            .sl-card-hover:hover .sl-icon-container {
              transform: scale(1.05);
            }
            .chooseFLow773{
            padding: 20px 24px;}

            @media (max-width: 480px) {
            
              .chooseFLow773{
                padding: 16px 10px;
              }
            }
          `}</style>

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(4px)",
          zIndex: 9998,
          animation: "slFadeIn 0.3s ease",
        }}
        onClick={onClose}
      />

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "white",
          borderRadius: "16px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          zIndex: 9999,
          maxWidth: "480px",
          width: "98%",
          maxHeight: "90vh",
          overflow: "hidden",
          animation: "slModalSlideUp 0.3s ease forwards",
        }}
      >
        <div
          style={{
            padding: "20px 24px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#1a1a1a", margin: 0 }}>Add Stock</h2>
            <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>Choose how you'd like to add products</p>
          </div>
          <button
            className='sl-close-hover'
            style={{
              background: "#f3f4f6",
              border: "none",
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              flexShrink: 0,
            }}
            onClick={onClose}
          >
            <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='#6b7280' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <line x1='18' y1='6' x2='6' y2='18' />
              <line x1='6' y1='6' x2='18' y2='18' />
            </svg>
          </button>
        </div>

        <div className='chooseFLow773'>
          <div style={{ display: "grid", gap: "12px" }}>
            <div
              className='sl-card-hover'
              style={{
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px 18px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                background: "white",
              }}
              onClick={handleManualClick}
            >
              <div
                className='sl-icon-container'
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "all 0.3s ease",
                  background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                }}
              >
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#2563eb' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' />
                  <path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' />
                </svg>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#1a1a1a", display: "flex", alignItems: "center", gap: "8px" }}>
                  Create Manually
                  <span
                    style={{
                      background: "linear-gradient(135deg, #fef3c7, #fde68a)",
                      color: "#92400e",
                      fontSize: "10px",
                      fontWeight: "600",
                      padding: "2px 7px",
                      borderRadius: "4px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Recommended
                  </span>
                </div>
                <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.4", margin: 0 }}>
                  Add products individually with complete control over details and specifications.
                </p>
              </div>
            </div>

            <div
              className='sl-card-hover'
              style={{
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px 18px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                background: "white",
              }}
              onClick={handleFileClick}
            >
              <div
                className='sl-icon-container'
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "all 0.3s ease",
                  background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
                }}
              >
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#059669' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
                  <polyline points='17 8 12 3 7 8' />
                  <line x1='12' y1='3' x2='12' y2='15' />
                </svg>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#1a1a1a" }}>Upload from File</div>
                <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.4", margin: 0 }}>
                  Import multiple products at once using CSV or Excel files for bulk additions.
                </p>
              </div>
            </div>

            <div
              className='sl-card-hover'
              style={{
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px 18px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                background: "white",
              }}
              onClick={handleAIClick}
            >
              <div
                className='sl-icon-container'
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "all 0.3s ease",
                  background: "linear-gradient(135deg, #fae8ff, #f3e8ff)",
                }}
              >
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#9333ea' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' />
                  <circle cx='12' cy='13' r='4' />
                </svg>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#1a1a1a", display: "flex", alignItems: "center", gap: "8px" }}>
                  Scan Product List
                  <span
                    style={{
                      background: "linear-gradient(135deg, #fae8ff, #f3e8ff)",
                      color: "#6b21a8",
                      fontSize: "11px",
                      fontWeight: "600",
                      padding: "3px 8px",
                      borderRadius: "4px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    AI Powered
                  </span>
                </div>
                <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.4", margin: 0 }}>
                  Take a photo of your product list and let AI automatically create your catalog.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            padding: "16px 24px",
            background: "#f9fafb",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#6b7280' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <circle cx='12' cy='12' r='10' />
            <line x1='12' y1='16' x2='12' y2='12' />
            <line x1='12' y1='8' x2='12.01' y2='8' />
          </svg>
          <span style={{ fontSize: "12px", color: "#6b7280", lineHeight: "1.4" }}>
            More details will be provided on the next page after selecting an option.
          </span>
        </div>
      </div>
    </>
  );
};

export default AddStockModal;
